module.exports = __webpack_public_path__ + "static/section-4-left-658b7333c99db0e4d454a75ed732e555.png";